import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { buildValidationSuccessfulResult } from "../util";
import { isAnyOrderRefunding } from "@/utils/OrderUtils";
import { confirm } from "@/utils";
import { ShipValidationRule, ShipValidationRuleKey } from "../type";

export async function validateRefundingOrder(orders: OrderDTO[], rule: ShipValidationRule) {
    if (!rule[ShipValidationRuleKey.checkRefundingOrder]) return buildValidationSuccessfulResult(orders);

    if (isAnyOrderRefunding(orders)) {
        await confirm("所选订单中包含退款中订单，是否继续发货？");
    }

    return buildValidationSuccessfulResult(orders);
}
